import { ReportActions } from "../actions";

const initialState = {
  allReportSolicitationJob: [],
  dailyAllReportSolicitationJob: [],
  reports: [],
  history: [],
};

export default function report(state = initialState, action) {
  switch (action.type) {
    case ReportActions.ACTION_SAVE_ALL_REPORTS_SOLICITATION_JOB:
      return {
        ...state,
        allReportSolicitationJob: action.payload,
      };
    case ReportActions.ACTION_SAVE_REPORTS:
      return {
        ...state,
        reports: action.payload,
      };
    case ReportActions.ACTION_SAVE_DAILY_REPORTS_SOLICITATION_JOB:
      return {
        ...state,
        dailyAllReportSolicitationJob: action.payload,
      };
    case ReportActions.ACTION_SAVE_HISTORY:
      return {
        ...state,
        history: action.payload,
      };
    default:
      return state;
  }
}

export function getAllReportSolicitationJob(state) {
  return state.report.allReportSolicitationJob;
}

export function getDailyAllReportSolicitationJob(state) {
  return state.report.dailyAllReportSolicitationJob;
}

export function getReports(state) {
  return state.report.reports;
}

export function getHistory(state) {
  return state.report.history;
}
